import React, {createContext} from 'react'

const ValidContext = createContext({})

export const ValidProvider = ValidContext.Provider

export default ValidContext
